import * as React from 'react';

import './TagLabel.css';

export class TagLabel extends React.Component {
    render(){
        return <div className={"tag-label " + this.props.size} {...this.props}>{this.props.text}</div>
    }
}